import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ChakraProvider } from '@chakra-ui/react';
import { extendTheme } from '@chakra-ui/react';
import store from './redux/store'; //Import the store
// Styles
import './App.css';
// Fonts
import './assets/fonts/fonts.css';
 // Pages
import LoginPage from './pages/login/login';
// Pages > Settings
import SettingsParamsViewPage from './pages/settings/params/view/view';
import SettingsParamsFormPage from './pages/settings/params/form/form';
// Pages > Users
import UsersViewPage from './pages/users/view/view';
import UsersFormPage from './pages/users/form/form';
import UsersDetailPage from './pages/users/detail/detail';
// Pages > Live
import LiveViewPage from './pages/live/view/view';
import LiveFormPage from './pages/live/form/form';
import LiveDetailPage from './pages/live/detail/detail';
// Pages > News
import NewsViewPage from './pages/news/view/view';
import NewsFormPage from './pages/news/form/form';
import NewsDetailPage from './pages/news/detail/detail';
// Pages > Podcasts
import PodcastsViewPage from './pages/podcasts/view/view';
import PodcastsFormPage from './pages/podcasts/form/form';
import PodcastsDetailPage from './pages/podcasts/detail/detail';
// Pages > Podcasts groups
import PodcastsGroupsViewPage from './pages/podcastsGroups/view/view';
import PodcastsGroupsFormPage from './pages/podcastsGroups/form/form';
import PodcastsGroupsDetailPage from './pages/podcastsGroups/detail/detail';
// Pages > Push notifications
import PushNotificationsViewPage from './pages/pushNotifications/view/view';
import PushNotificationsFormPage from './pages/pushNotifications/form/form';
import PushNotificationsDetailPage from './pages/pushNotifications/detail/detail';
// Utils
import { isMobileDevice } from './utils/utils';
import { initGlobals } from './utils/globals';

const colors = {
	primary: "var(--color-blue)",
	dark: "var(--color-darkblue)",
	white: "var(--color-white)",
	light: "var(--color-cream)",
  header: "var(--color-darkblue)",
  menu: "var(--color-blue)",
  hover: "var(--color-skyblue)",
  info: "var(--color-info)",
  ok: "var(--color-ok)",
  ko: "var(--color-ko)",
  grid_alternate_row: "var(--color-grid-alternate-row)",
  card: "var(--color-card)",
  border: "var(--color-border)",
};

const fonts = {
	heading: `Manrope, 'Open Sans', sans-serif`,
	body: `Manrope, Raleway, sans-serif`,
};

const theme = extendTheme({ colors, fonts });

// Initialize global variables
initGlobals();

function App() {
  // const toast = useToast();

  useEffect(() => {

    // Attaching the event listener function to window's resize event
    window.addEventListener("resize", onResize);

    checkMobile();

    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);

  const onResize = (e) => {
    // console.log("App > onResize", e);
    checkMobile();
  };

  const checkMobile = () => {
    const isMobile = isMobileDevice();
    // console.log("isMobile", isMobile);
    if (isMobile) {
      // Add class to body if it´s mobile device
      document.body.classList.add('mobile-device');
    } else {
      // Remove class
      document.body.classList.remove('mobile-device');
    }
  };

	return (
		<ChakraProvider theme={theme}>
			<Provider store={store}>
				<Router>
					<Routes>
						<Route path="/" element={<LoginPage />} />
            <Route path="/home" element={<SettingsParamsViewPage />} />
            {/* Settings */}
            <Route path="/settings" element={<SettingsParamsViewPage />} />
            <Route path="/settings_params" element={<SettingsParamsViewPage />} />
						<Route path="/settings_params/new" element={<SettingsParamsFormPage isNew={true} />} />
						<Route path="/settings_params/edit/:id" element={<SettingsParamsFormPage isNew={false} />} />
            {/* Users */}
						<Route path="/users" element={<UsersViewPage />} />
						<Route path="/users/new" element={<UsersFormPage isNew={true} />} />
						<Route path="/users/edit/:id" element={<UsersFormPage isNew={false} />} />
						<Route path="/users/detail/:id" element={<UsersDetailPage />} />
            {/* Live */}
						<Route path="/live" element={<LiveViewPage />} />
						<Route path="/live/new" element={<LiveFormPage isNew={true} />} />
						<Route path="/live/edit/:id" element={<LiveFormPage isNew={false} />} />
						<Route path="/live/detail/:id" element={<LiveDetailPage />} />        
            {/* News */}
						<Route path="/news" element={<NewsViewPage />} />
						<Route path="/news/new" element={<NewsFormPage isNew={true} />} />
						<Route path="/news/edit/:id" element={<NewsFormPage isNew={false} />} />
						<Route path="/news/detail/:id" element={<NewsDetailPage />} />      
            {/* Podcasts */}
						<Route path="/podcasts" element={<PodcastsViewPage />} />
						<Route path="/podcasts/new" element={<PodcastsFormPage isNew={true} />} />
						<Route path="/podcasts/edit/:id" element={<PodcastsFormPage isNew={false} />} />
						<Route path="/podcasts/detail/:id" element={<PodcastsDetailPage />} />  
            {/* Podcasts groups */}
						<Route path="/podcasts_groups" element={<PodcastsGroupsViewPage />} />
						<Route path="/podcasts_groups/new" element={<PodcastsGroupsFormPage isNew={true} />} />
						<Route path="/podcasts_groups/edit/:id" element={<PodcastsGroupsFormPage isNew={false} />} />
						<Route path="/podcasts_groups/detail/:id" element={<PodcastsGroupsDetailPage />} />
            {/* Push notifications */}
						<Route path="/push_notifications" element={<PushNotificationsViewPage />} />
						<Route path="/push_notifications/new" element={<PushNotificationsFormPage isNew={true} />} />
						<Route path="/push_notifications/edit/:id" element={<PushNotificationsFormPage isNew={false} />} />
						<Route path="/push_notifications/detail/:id" element={<PushNotificationsDetailPage />} />
					</Routes>
				</Router>
			</Provider>
		</ChakraProvider>
	);
}

export default App;
